<script setup lang="ts">

export type MenuEntry = {
  label: string
  href: string
}

withDefaults(defineProps<{
    logoUrl?: string | null | undefined
    menu?: MenuEntry[]
  }>(),
  {
    logoUrl: "/assets/images/lyrics_learn1.png",
    menu: () => [
      {label: "How it Works", href: "/how-it-works"},
      {label: "Research", href: "/research"},
      {label: "Schools/Districts", href: "/district"},
      {label: "Online Tutoring", href: "/tutor"},
      {label: "Homeschool", href: "/homeschool"},
      {label: "Pricing", href: "/pricing"},
      {label: "Free Trial", href: "/sign-up"},
    ]
  }
)
</script>

<template>
  <b-navbar class="home-nav-bar" toggleable="lg" type="dark" variant="primary">
    <slot name="brand">
      <b-navbar-brand v-if="logoUrl" href="/">
        <img class="logo" :src="logoUrl" alt="L2L Logo">
      </b-navbar-brand>
    </slot>

    <b-navbar-toggle target="nav-collapse"/>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="mx-auto">
        <slot name="nav-left"/>
        <slot name="nav-center">
          <b-nav-item v-for="entry in menu" :key="entry.label" class="menu-item" :href="entry.href">
            {{ entry.label }}
          </b-nav-item>
        </slot>
        <slot name="nav-right"/>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<style scoped lang="scss">
@import '../../../sass/theme';

.home-nav-bar {
  position: sticky;
  top: 0;
  z-index: 9999;
  max-height: 3rem;

  width: 100%;
  padding: 0; // override default bootstrap padding on .nav
  display: flex;


  .logo {
    width: 9.5rem;
  }

  .menu-item {
    margin: 0 0.75rem;
  }
}
</style>
